import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './content.css';
import img1 from '../../../assets/images/img1.png';
import img2 from '../../../assets/images/img2.png';
import img3 from '../../../assets/images/img3.png';
import img4 from '../../../assets/images/img4.png';
import { useSelector } from 'react-redux';

const ScrollContent = () => {
  const data = useSelector((store) => store.data.HomeData);
  const [cardData, setCardData] = useState({});

  useEffect(() => {
    if (data?.items?.length) {
      const introData = data.items.find((ele) => ele.Section === "IntroFeatures");
      if (introData) {
        setCardData(introData.Content);
      }
    }
  }, [data]);


  const cardVariants = {
    hidden: { opacity: 0, y: 80 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.2,
        duration: 0.8,
        ease: "easeOut", 
      },
    }),
  };

  if (!cardData?.Features) return null;

  return (
    <div className="content-wrapper">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
        viewport={{  amount: 0.3 }}
        className="heading1 capitalize-first-letter"
      >
        {cardData.Title}
      </motion.h2>

      <div className="cards-container1">
        {cardData?.Features?.map((card, index) => (
          <motion.div
            key={index}
            className="card"
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 3, ease: "easeOut" }}
            viewport={{ amount: 0.4 }}
            custom={index}
          >
             <motion.div
            key={index}
            variants={cardVariants}
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 3, ease: "easeOut" }}
            viewport={{ amount: 0.4 }}
            custom={index}
          >
            <img src={card.icon} height={120} width={120} alt="Not Found" />
            </motion.div>
            <div>
              <h2 className="mt-3 fw-bold capitalize-first-letter">{card.Title}</h2>
              <p className="mt-2 content-desc">{card.Description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ScrollContent;
